import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import {setChosenTimesheet, setTimesheet} from "../storage/toolkit";

// Імпортуємо axiosConfig для інтерсепторів
import "../api/axiosConfig";

export const SetTimesheet = (dispatch: any, year?: number) => {
    const date = new Date()

    // Ensure year is a valid number, default to current year
    year = (year && !isNaN(year)) ? year : date.getFullYear()

    axios.get(getApiLink(`/api/timesheet/my/?year=${year}`)).then(({data}) => {
        dispatch(setTimesheet(data))
        // dispatch(setChosenTimesheet(data[0]))
    }).catch(er => {
        console.log("SetTimesheet error:", er)
    })
}